import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turnstile"
export default class extends Controller {
  static values = {
    sitekey: String,
  };

  connect() {
    this.render();
  }

  render() {
    turnstile.render(this.element, {
      sitekey: this.sitekeyValue,
    });
  }
}
